import Swal from "sweetalert2";

const confirmDelete = (onConfirm, itemName = "this record") =>
  Swal.fire({
    title: "Are you sure?",
    text: `Delete ${itemName}? This action cannot be undone.`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#e02424",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, delete",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) onConfirm();
  });

export default confirmDelete;
